import { IonSpinner } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import {
  sugerenciaReset,
  wsPostSugerencia,
} from "../../../context/Actions/sugerencia/sugerencia";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { PortalContext } from "../../../context/Provider";
import { sugerenciaTxt } from "../../../pages/Sugerencias/SugerenciasTxt";
import camelize from "../../../../global/utils/camelize";
import "./SugerenciaCmp.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const SugerenciaCmp = () => {
  const { modalState, pacienteDispatch, sugerenciaDispatch, sugerenciaState } =
    useContext(PortalContext);

  // Cambio de contexto
  const { authState, authDispatch, toasterDispatch, toasterState } =
    useContext(GlobalContext);

  const [btnDisabled, setBtnDisabled] = useState(true);
  const [formularioSugerencia, setFormularioSugerencia] = useState({
    sugerencia: "",
    mail: authState.auth.data.paciente.email,
    anonimo: false,
    bandera: true,
    nombrePaciente: authState.auth.data.paciente.nombre,
    telefono: authState.auth.data.paciente.telefono,
  });

  const nameCamelized = () => {
    let name = authState.auth.data.paciente.nombre;
    return camelize(name);
  };

  const onChangeSugerencia = (e) => {
    if (e.target.value.length > 2) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    setFormularioSugerencia({
      ...formularioSugerencia,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeCheckSugerencia = (e) => {
    if (e.target.checked) {
      setFormularioSugerencia({
        ...formularioSugerencia,
        anonimo: true,
      });
    } else {
      setFormularioSugerencia({
        ...formularioSugerencia,
        anonimo: false,
      });
    }
  };

  const enviarSugerencia = () => {
    wsPostSugerencia(formularioSugerencia)(sugerenciaDispatch);
  };

  useEffect(() => {
    if (
      sugerenciaState.sugerencia.data === "" &&
      sugerenciaState.sugerencia.data !== null
    ) {
      showToaster(
        {
          texto: "Sugerencia enviada correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      sugerenciaReset()(sugerenciaDispatch);
      // Se utilizo un timeout para darle a la pagina unos
      // segundos y que muestre el toaster correctamente y luego refresca
      setTimeout(() => {
        window.location.reload(false);
      }, 3000);
    }
    //eslint-disable-next-line
  }, [sugerenciaState.sugerencia.data]);

  useEffect(() => {
    if (toasterState.toaster.show) {
      setBtnDisabled(true);
    }
  }, [toasterState.toaster.show]);

  return (
    <>
      <div className="ptur-sugerencia-texto">
        <span className="rb16b">
          {nameCamelized()}
          {""}
        </span>
        <span>{sugerenciaTxt}</span>
      </div>
      <div className="ptur-sugerencia-textarea-container">
        <InputV1
          disabledEjemplo={true}
          className="ptur-sugerencia-textarea"
          name="sugerencia"
          placeholder="Escribí tu sugerencia..."
          onChange={onChangeSugerencia}
          inputType="textarea"
          maxLength="1000"
        />
      </div>
      <div className="ptur-sugerencia-envio">
        <div className="ptur-sugerencia-checkenvio">
          <InputV1
            inputType="check"
            name="anonimo"
            id="anonimo"
            onChange={onChangeCheckSugerencia}
            checkboxStr="Enviar sugerencia como anónimo"
          />
        </div>
        <div className="ptur-sugerencia-boton-container">
          <button
            disabled={btnDisabled || sugerenciaState.sugerencia.loading}
            className={
              btnDisabled || sugerenciaState.sugerencia.loading
                ? "ptur-btn-sugerencia bgc-grey65 c-white rb16l"
                : "ptur-btn-sugerencia bgc-latex10 c-white rb16l"
            }
            onClick={enviarSugerencia}
          >
            {sugerenciaState.sugerencia.loading ? (
              <div className="ptur-sugerencia-envio-loading">
                <IonSpinner name="lines-small" />
              </div>
            ) : (
              "Enviar sugerencia"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default SugerenciaCmp;
